export const OUTBOUND_NOT_ALLOWED_STATUSES = [
	'trash',
	'resigned',
	'shift',
	'no_response',
];
